/* tslint:disable */
/* eslint-disable */
/**
 * Kinde Management API
 * Provides endpoints to manage your Kinde Businesses
 *
 * The version of the OpenAPI document: 1
 * Contact: support@kinde.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime.js';
import { AddOrganizationUsersRequestToJSON, AddOrganizationUsersResponseFromJSON, CreateOrganizationRequestToJSON, CreateOrganizationResponseFromJSON, CreateOrganizationUserPermissionRequestToJSON, CreateOrganizationUserRoleRequestToJSON, GetOrganizationFeatureFlagsResponseFromJSON, GetOrganizationUsersResponseFromJSON, GetOrganizationsResponseFromJSON, GetOrganizationsUserPermissionsResponseFromJSON, GetOrganizationsUserRolesResponseFromJSON, GetPropertyValuesResponseFromJSON, OrganizationFromJSON, SuccessResponseFromJSON, UpdateOrganizationPropertiesRequestToJSON, UpdateOrganizationRequestToJSON, UpdateOrganizationUsersRequestToJSON, UpdateOrganizationUsersResponseFromJSON, } from '../models/index.js';
/**
 *
 */
var OrganizationsApi = /** @class */ (function (_super) {
    __extends(OrganizationsApi, _super);
    function OrganizationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add existing users to an organization.
     * Add Organization Users
     */
    OrganizationsApi.prototype.addOrganizationUsersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling addOrganizationUsers.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: AddOrganizationUsersRequestToJSON(requestParameters.addOrganizationUsersRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return AddOrganizationUsersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Add existing users to an organization.
     * Add Organization Users
     */
    OrganizationsApi.prototype.addOrganizationUsers = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.addOrganizationUsersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create an organization.
     * Create Organization
     */
    OrganizationsApi.prototype.createOrganizationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createOrganizationRequest === null || requestParameters.createOrganizationRequest === undefined) {
                            throw new runtime.RequiredError('createOrganizationRequest', 'Required parameter requestParameters.createOrganizationRequest was null or undefined when calling createOrganization.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organization",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CreateOrganizationRequestToJSON(requestParameters.createOrganizationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CreateOrganizationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create an organization.
     * Create Organization
     */
    OrganizationsApi.prototype.createOrganization = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrganizationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add permission to an organization user.
     * Add Organization User Permission
     */
    OrganizationsApi.prototype.createOrganizationUserPermissionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling createOrganizationUserPermission.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling createOrganizationUserPermission.');
                        }
                        if (requestParameters.createOrganizationUserPermissionRequest === null || requestParameters.createOrganizationUserPermissionRequest === undefined) {
                            throw new runtime.RequiredError('createOrganizationUserPermissionRequest', 'Required parameter requestParameters.createOrganizationUserPermissionRequest was null or undefined when calling createOrganizationUserPermission.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users/{user_id}/permissions".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("user_id", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CreateOrganizationUserPermissionRequestToJSON(requestParameters.createOrganizationUserPermissionRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Add permission to an organization user.
     * Add Organization User Permission
     */
    OrganizationsApi.prototype.createOrganizationUserPermission = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrganizationUserPermissionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Add role to an organization user.
     * Add Organization User Role
     */
    OrganizationsApi.prototype.createOrganizationUserRoleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling createOrganizationUserRole.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling createOrganizationUserRole.');
                        }
                        if (requestParameters.createOrganizationUserRoleRequest === null || requestParameters.createOrganizationUserRoleRequest === undefined) {
                            throw new runtime.RequiredError('createOrganizationUserRoleRequest', 'Required parameter requestParameters.createOrganizationUserRoleRequest was null or undefined when calling createOrganizationUserRole.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users/{user_id}/roles".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("user_id", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: CreateOrganizationUserRoleRequestToJSON(requestParameters.createOrganizationUserRoleRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Add role to an organization user.
     * Add Organization User Role
     */
    OrganizationsApi.prototype.createOrganizationUserRole = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrganizationUserRoleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an organization.
     * Delete Organization
     */
    OrganizationsApi.prototype.deleteOrganizationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling deleteOrganization.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organization/{org_code}".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete an organization.
     * Delete Organization
     */
    OrganizationsApi.prototype.deleteOrganization = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrganizationRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete organization feature flag override.
     * Delete Organization Feature Flag Override
     */
    OrganizationsApi.prototype.deleteOrganizationFeatureFlagOverrideRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling deleteOrganizationFeatureFlagOverride.');
                        }
                        if (requestParameters.featureFlagKey === null || requestParameters.featureFlagKey === undefined) {
                            throw new runtime.RequiredError('featureFlagKey', 'Required parameter requestParameters.featureFlagKey was null or undefined when calling deleteOrganizationFeatureFlagOverride.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/feature_flags/{feature_flag_key}".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("feature_flag_key", "}"), encodeURIComponent(String(requestParameters.featureFlagKey))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete organization feature flag override.
     * Delete Organization Feature Flag Override
     */
    OrganizationsApi.prototype.deleteOrganizationFeatureFlagOverride = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrganizationFeatureFlagOverrideRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete all organization feature flag overrides.
     * Delete Organization Feature Flag Overrides
     */
    OrganizationsApi.prototype.deleteOrganizationFeatureFlagOverridesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling deleteOrganizationFeatureFlagOverrides.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/feature_flags".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete all organization feature flag overrides.
     * Delete Organization Feature Flag Overrides
     */
    OrganizationsApi.prototype.deleteOrganizationFeatureFlagOverrides = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrganizationFeatureFlagOverridesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete organization handle
     * Delete organization handle
     */
    OrganizationsApi.prototype.deleteOrganizationHandleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling deleteOrganizationHandle.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organization/{org_code}/handle".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete organization handle
     * Delete organization handle
     */
    OrganizationsApi.prototype.deleteOrganizationHandle = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrganizationHandleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete permission for an organization user.
     * Delete Organization User Permission
     */
    OrganizationsApi.prototype.deleteOrganizationUserPermissionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling deleteOrganizationUserPermission.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteOrganizationUserPermission.');
                        }
                        if (requestParameters.permissionId === null || requestParameters.permissionId === undefined) {
                            throw new runtime.RequiredError('permissionId', 'Required parameter requestParameters.permissionId was null or undefined when calling deleteOrganizationUserPermission.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users/{user_id}/permissions/{permission_id}".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("user_id", "}"), encodeURIComponent(String(requestParameters.userId))).replace("{".concat("permission_id", "}"), encodeURIComponent(String(requestParameters.permissionId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete permission for an organization user.
     * Delete Organization User Permission
     */
    OrganizationsApi.prototype.deleteOrganizationUserPermission = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrganizationUserPermissionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete role for an organization user.
     * Delete Organization User Role
     */
    OrganizationsApi.prototype.deleteOrganizationUserRoleRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling deleteOrganizationUserRole.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling deleteOrganizationUserRole.');
                        }
                        if (requestParameters.roleId === null || requestParameters.roleId === undefined) {
                            throw new runtime.RequiredError('roleId', 'Required parameter requestParameters.roleId was null or undefined when calling deleteOrganizationUserRole.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users/{user_id}/roles/{role_id}".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("user_id", "}"), encodeURIComponent(String(requestParameters.userId))).replace("{".concat("role_id", "}"), encodeURIComponent(String(requestParameters.roleId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete role for an organization user.
     * Delete Organization User Role
     */
    OrganizationsApi.prototype.deleteOrganizationUserRole = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteOrganizationUserRoleRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets an organization given the organization\'s code.
     * Get Organization
     */
    OrganizationsApi.prototype.getOrganizationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.code !== undefined) {
                            queryParameters['code'] = requestParameters.code;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organization",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return OrganizationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets an organization given the organization\'s code.
     * Get Organization
     */
    OrganizationsApi.prototype.getOrganization = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all organization feature flags.
     * List Organization Feature Flags
     */
    OrganizationsApi.prototype.getOrganizationFeatureFlagsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling getOrganizationFeatureFlags.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/feature_flags".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return GetOrganizationFeatureFlagsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get all organization feature flags.
     * List Organization Feature Flags
     */
    OrganizationsApi.prototype.getOrganizationFeatureFlags = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationFeatureFlagsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Gets properties for an organization by org code.
     * Get Organization Property Values
     */
    OrganizationsApi.prototype.getOrganizationPropertyValuesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling getOrganizationPropertyValues.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/properties".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return GetPropertyValuesResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Gets properties for an organization by org code.
     * Get Organization Property Values
     */
    OrganizationsApi.prototype.getOrganizationPropertyValues = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationPropertyValuesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get permissions for an organization user.
     * List Organization User Permissions
     */
    OrganizationsApi.prototype.getOrganizationUserPermissionsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling getOrganizationUserPermissions.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling getOrganizationUserPermissions.');
                        }
                        queryParameters = {};
                        if (requestParameters.expand !== undefined) {
                            queryParameters['expand'] = requestParameters.expand;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users/{user_id}/permissions".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("user_id", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return GetOrganizationsUserPermissionsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get permissions for an organization user.
     * List Organization User Permissions
     */
    OrganizationsApi.prototype.getOrganizationUserPermissions = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationUserPermissionsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get roles for an organization user.
     * List Organization User Roles
     */
    OrganizationsApi.prototype.getOrganizationUserRolesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling getOrganizationUserRoles.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling getOrganizationUserRoles.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users/{user_id}/roles".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("user_id", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return GetOrganizationsUserRolesResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get roles for an organization user.
     * List Organization User Roles
     */
    OrganizationsApi.prototype.getOrganizationUserRoles = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationUserRolesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get users in an organization.
     * List Organization Users
     */
    OrganizationsApi.prototype.getOrganizationUsersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling getOrganizationUsers.');
                        }
                        queryParameters = {};
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['page_size'] = requestParameters.pageSize;
                        }
                        if (requestParameters.nextToken !== undefined) {
                            queryParameters['next_token'] = requestParameters.nextToken;
                        }
                        if (requestParameters.permissions !== undefined) {
                            queryParameters['permissions'] = requestParameters.permissions;
                        }
                        if (requestParameters.roles !== undefined) {
                            queryParameters['roles'] = requestParameters.roles;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return GetOrganizationUsersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get users in an organization.
     * List Organization Users
     */
    OrganizationsApi.prototype.getOrganizationUsers = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationUsersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a list of organizations.
     * List Organizations
     */
    OrganizationsApi.prototype.getOrganizationsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['page_size'] = requestParameters.pageSize;
                        }
                        if (requestParameters.nextToken !== undefined) {
                            queryParameters['next_token'] = requestParameters.nextToken;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return GetOrganizationsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a list of organizations.
     * List Organizations
     */
    OrganizationsApi.prototype.getOrganizations = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Remove user from an organization.
     * Remove Organization User
     */
    OrganizationsApi.prototype.removeOrganizationUserRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling removeOrganizationUser.');
                        }
                        if (requestParameters.userId === null || requestParameters.userId === undefined) {
                            throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling removeOrganizationUser.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users/{user_id}".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("user_id", "}"), encodeURIComponent(String(requestParameters.userId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Remove user from an organization.
     * Remove Organization User
     */
    OrganizationsApi.prototype.removeOrganizationUser = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeOrganizationUserRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an organization.
     * Update Organization
     */
    OrganizationsApi.prototype.updateOrganizationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling updateOrganization.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organization/{org_code}".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UpdateOrganizationRequestToJSON(requestParameters.updateOrganizationRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an organization.
     * Update Organization
     */
    OrganizationsApi.prototype.updateOrganization = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrganizationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update organization feature flag override.
     * Update Organization Feature Flag Override
     */
    OrganizationsApi.prototype.updateOrganizationFeatureFlagOverrideRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling updateOrganizationFeatureFlagOverride.');
                        }
                        if (requestParameters.featureFlagKey === null || requestParameters.featureFlagKey === undefined) {
                            throw new runtime.RequiredError('featureFlagKey', 'Required parameter requestParameters.featureFlagKey was null or undefined when calling updateOrganizationFeatureFlagOverride.');
                        }
                        if (requestParameters.value === null || requestParameters.value === undefined) {
                            throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling updateOrganizationFeatureFlagOverride.');
                        }
                        queryParameters = {};
                        if (requestParameters.value !== undefined) {
                            queryParameters['value'] = requestParameters.value;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/feature_flags/{feature_flag_key}".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("feature_flag_key", "}"), encodeURIComponent(String(requestParameters.featureFlagKey))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update organization feature flag override.
     * Update Organization Feature Flag Override
     */
    OrganizationsApi.prototype.updateOrganizationFeatureFlagOverride = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrganizationFeatureFlagOverrideRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update organization property values.
     * Update Organization Property values
     */
    OrganizationsApi.prototype.updateOrganizationPropertiesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling updateOrganizationProperties.');
                        }
                        if (requestParameters.updateOrganizationPropertiesRequest === null || requestParameters.updateOrganizationPropertiesRequest === undefined) {
                            throw new runtime.RequiredError('updateOrganizationPropertiesRequest', 'Required parameter requestParameters.updateOrganizationPropertiesRequest was null or undefined when calling updateOrganizationProperties.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/properties".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UpdateOrganizationPropertiesRequestToJSON(requestParameters.updateOrganizationPropertiesRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update organization property values.
     * Update Organization Property values
     */
    OrganizationsApi.prototype.updateOrganizationProperties = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrganizationPropertiesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update organization property value.
     * Update Organization Property value
     */
    OrganizationsApi.prototype.updateOrganizationPropertyRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling updateOrganizationProperty.');
                        }
                        if (requestParameters.propertyKey === null || requestParameters.propertyKey === undefined) {
                            throw new runtime.RequiredError('propertyKey', 'Required parameter requestParameters.propertyKey was null or undefined when calling updateOrganizationProperty.');
                        }
                        if (requestParameters.value === null || requestParameters.value === undefined) {
                            throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling updateOrganizationProperty.');
                        }
                        queryParameters = {};
                        if (requestParameters.value !== undefined) {
                            queryParameters['value'] = requestParameters.value;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/properties/{property_key}".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))).replace("{".concat("property_key", "}"), encodeURIComponent(String(requestParameters.propertyKey))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SuccessResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update organization property value.
     * Update Organization Property value
     */
    OrganizationsApi.prototype.updateOrganizationProperty = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrganizationPropertyRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update users that belong to an organization.
     * Update Organization Users
     */
    OrganizationsApi.prototype.updateOrganizationUsersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgCode === null || requestParameters.orgCode === undefined) {
                            throw new runtime.RequiredError('orgCode', 'Required parameter requestParameters.orgCode was null or undefined when calling updateOrganizationUsers.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("kindeBearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{org_code}/users".replace("{".concat("org_code", "}"), encodeURIComponent(String(requestParameters.orgCode))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: UpdateOrganizationUsersRequestToJSON(requestParameters.updateOrganizationUsersRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return UpdateOrganizationUsersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update users that belong to an organization.
     * Update Organization Users
     */
    OrganizationsApi.prototype.updateOrganizationUsers = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrganizationUsersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OrganizationsApi;
}(runtime.BaseAPI));
export { OrganizationsApi };
/**
 * @export
 */
export var GetOrganizationUsersSortEnum = {
    NameAsc: 'name_asc',
    NameDesc: 'name_desc',
    EmailAsc: 'email_asc',
    EmailDesc: 'email_desc'
};
/**
 * @export
 */
export var GetOrganizationsSortEnum = {
    NameAsc: 'name_asc',
    NameDesc: 'name_desc',
    EmailAsc: 'email_asc',
    EmailDesc: 'email_desc'
};
